    <p *ngIf="isEnabled">
        Stav aplikacie : {{message}}
        <button *ngIf="!updateReady"  (click)="check()">Skontroluj verziu</button>
        <button *ngIf="updateReady" (click)="reload()">Aktualizuj</button>
    </p>
